import React from "react";

import { getTenFlags } from "../utils/helpers";
import LeftQuote from "../assets/left-quote.svg";
import PrimayDarkBtn from "./PrimayDarkBtn";

const allQuotes = [
  {
    name: "Tedalech",
    location: "Ethiopia",
    comment:
      "My transactions were easy and quick. Excellent servie will definitely recommend.",
  },
  {
    name: "Halima Sharif",
    location: "Tanzania",
    comment:
      "All I can say is Tanaad is the best way to send money around the world, because they are going to help you through any issues with sending and receiving money.",
  },
  {
    name: "James",
    location: "Nairobi",
    comment:
      "Thank You Tanaad. This is the most convenient way of sending money to family and friends. Tanaad makes the world smaller indeed. Thank you.",
  },
];

const quotes = getTenFlags(allQuotes);

function CustomerExperience({ onClick }) {
  return (
    <>
      <section className="w-100 position-relative">
        <img
          src={LeftQuote}
          alt="Openning Quotes"
          className="position-absolute max-width-40pm center-absolute-pos z-index-1"
        />
        <div className="w-100 full-height linear-gradient-primary-bg-o py-5">
          <div className="container mt-4">
            <h3 className="fs-1 text-dark text-center mb-5">
              What our customers say
            </h3>
            <div>
              <div className="max-width-460 mx-auto">
                <div
                  id="customerExIndicators"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div
                    className="carousel-indicators"
                    style={{ bottom: "-60px" }}
                  >
                    {[0, 1, 2].map((i) => (
                      <button
                        key={i}
                        type="button"
                        data-bs-target="#customerExIndicators"
                        data-bs-slide-to={i}
                        className={`dark-primary-20 rounded-3 ${
                          i === 0 ? "active" : ""
                        }`}
                        style={{ width: "12px", height: "6px" }}
                        aria-current={i === 0 ? "true" : ""}
                        aria-label={`Slide ${i + 1}`}
                      ></button>
                    ))}
                  </div>

                  <div className="carousel-inner">
                    {quotes.map((quote, index) => (
                      <div
                        key={index}
                        className={`carousel-item ${
                          index === 0 ? "active" : ""
                        }`}
                      >
                        <div>
                          <p className="mb-4 text-center text-dark">
                            {quote.location === "Ethiopia" ? (
                              <span>
                                {quote.comment}
                                <span
                                  className="d-block"
                                  style={{ height: "23.5px" }}
                                ></span>
                              </span>
                            ) : (
                              quote.comment
                            )}
                          </p>
                          <p className="mb-0 text-center text-upper text-dark fs-12">
                            {quote.name}
                          </p>
                          <p className="mb-0 text-center text-upper dark-primary-20 fs-12">
                            - {quote.location}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="my-5 pt-5">
                <div
                  className="bg-dark mx-auto"
                  style={{ width: "75px", height: "6px" }}
                ></div>
              </div>
              <div className="mb-5">
                <h5 className="fs-2 text-dark text-center">
                  So what are you waiting for?
                </h5>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="w-100 position-relative">
        <div
          className="position-absolute start-50 d-flex justify-content-center align-items-center z-index-to-1"
          style={{ top: "-29px", transform: "translate(-50%, 0)" }}
        >
          <PrimayDarkBtn onClick={onClick} title="Send" url="/" />
        </div>
      </div>
    </>
  );
}

export default CustomerExperience;
